import { Action } from "redux";
import { isType } from "typescript-fsa";

import * as _ from "lodash";

import * as types from "../actions/actionTypes";
import * as actions from "../actions/selectEventsFromOtherCalendarsActions";

import { ICalendarPage, ISelectEventsFromOtherCalendarsState, IServer } from "../classes/state";

import { initialSelectEventsFromOtherCalendarsSettings } from "./initialState";

export default function selectEventsFromOtherCalendarsReducer(state: ISelectEventsFromOtherCalendarsState = initialSelectEventsFromOtherCalendarsSettings, action: Action): ISelectEventsFromOtherCalendarsState {

  if (isType(action, actions.setOpenSelectEventsFromOtherCalendarsModalAction)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      openSelectEventsFromOtherCalendarsModal: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.requestServersForCalendarSuccess)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      childServerIds: action.payload.childServerIds,
      currentServerId: action.payload.currentServerId,
      hasServerData: true,
      parentServerId: action.payload.parentServerId,
      rootServerId: action.payload.rootServerId,
      servers: inititialiseServers(action.payload.servers),

    };
    return newState;
  }

  if (isType(action, actions.updateServersSitesPagesAndCalendarsAction)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      servers: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.updateCheckedNodeItemIdsAction)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      checkedNodeItemIds: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.updateCheckedNodeCalendarIdsAction)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      checkedNodeCalendarIds: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.updateExpandedNodeItemIdsAction)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      expandedNodeItemIds: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.updateCurrentPageNumberAction)) {

    const newState: ISelectEventsFromOtherCalendarsState = {
      ...state,
      pager_currentPageNumber: action.payload,
    };
    return newState;
  }

  return state;
};

const inititialiseServers = (rawServers: IServer[]): IServer[] => {
  const servers: IServer[] = [];

  if (rawServers && rawServers.length && rawServers.length > 0) {
    for (const rawServer of rawServers) {
      const server: IServer = {
        calendarPages: null,
        name: rawServer.name,
        serverId: rawServer.serverId,
      };
      servers.push(server);
    }
  }

  return servers;
};
